import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "pop_up applicant_chk",
  style: {"display":"block","max-width":"1600px"}
}
const _hoisted_2 = { class: "pop_tit" }
const _hoisted_3 = { class: "date_wrap" }
const _hoisted_4 = {
  key: 0,
  class: "collection_period"
}
const _hoisted_5 = {
  key: 1,
  class: "end_point"
}
const _hoisted_6 = {
  key: 2,
  class: "activity_duration"
}
const _hoisted_7 = {
  key: 0,
  class: "list_container"
}
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "num_wrap" }
const _hoisted_10 = { class: "table_wrap custom_scroll" }
const _hoisted_11 = { style: {"table-layout":"auto","width":"100%"} }
const _hoisted_12 = { style: {"min-width":"130px","width":"auto"} }
const _hoisted_13 = { style: {"white-space":"nowrap"} }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = {
  key: 1,
  class: "list_container _flex"
}
const _hoisted_18 = { class: "left" }
const _hoisted_19 = { class: "num_wrap" }
const _hoisted_20 = { class: "list_wrap custom_scroll light_gray" }
const _hoisted_21 = {
  class: "_num",
  style: {"width":"10%"}
}
const _hoisted_22 = {
  class: "_name",
  style: {"width":"20%"}
}
const _hoisted_23 = {
  class: "_name",
  style: {"width":"30%","text-align":"left"}
}
const _hoisted_24 = {
  class: "_ph",
  style: {"width":"30%"}
}
const _hoisted_25 = {
  key: 0,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_26 = {
  key: 1,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_27 = {
  key: 2,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_28 = {
  key: 3,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_29 = {
  key: 4,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_30 = {
  key: 5,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_31 = {
  key: 6,
  class: "_ph",
  style: {"width":"15%"}
}
const _hoisted_32 = {
  class: "checkbox_wrap2",
  style: {"width":"40%"}
}
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = {
  class: "checkbox_wrap2",
  style: {"width":"40%"}
}
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = {
  class: "checkbox_wrap2",
  style: {"width":"40%"}
}
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = {
  class: "_date",
  style: {"width":"20%"}
}
const _hoisted_45 = { class: "memo_wrap" }
const _hoisted_46 = {
  key: 0,
  class: "cntWin_memo"
}
const _hoisted_47 = {
  key: 1,
  class: "step_content"
}
const _hoisted_48 = { class: "checkbox_wrap2" }
const _hoisted_49 = { class: "checkbox_wrap2" }
const _hoisted_50 = { class: "checkbox_wrap2" }
const _hoisted_51 = { class: "checkbox_wrap2" }
const _hoisted_52 = { class: "checkbox_wrap2" }
const _hoisted_53 = { class: "checkbox_wrap2" }
const _hoisted_54 = { class: "checkbox_wrap2" }
const _hoisted_55 = { class: "checkbox_wrap2" }
const _hoisted_56 = { class: "checkbox_wrap2" }
const _hoisted_57 = {
  key: 2,
  class: "btn_wrap _default _center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_AnswerModal = _resolveComponent("AnswerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn icon_wrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
      }, [...(_cache[28] || (_cache[28] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.data.title), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["state_tage", [$setup.state.data.state === 3 ? 'finish' : '']])
        }, _toDisplayString($setup.state.data.state === 3 ? "종료" : "모집중"), 3),
        ($setup.state.data.recruitStartDate && $setup.state.data.recruitEndDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[29] || (_cache[29] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 모집기간 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.recruitStartDate), ".", false)), 1),
              _cache[30] || (_cache[30] = _createElementVNode("em", null, "-", -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.recruitEndDate), ".", false)), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.state.data.applyDate !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[31] || (_cache[31] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 신청종료일 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.state.data.applyDate !== null ? $setup.CommonUtils.dateFormat(new Date($setup.state.data.applyDate), ".", false) : ""), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.state.data.activeStartDate && $setup.state.data.activeEndDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[32] || (_cache[32] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/cal_icon_blue.png",
                  alt: ""
                }),
                _createTextVNode(" 활동기간 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.activeStartDate), ".", false)), 1),
              _cache[33] || (_cache[33] = _createElementVNode("em", null, "-", -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.activeEndDate), ".", false)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      ($setup.state.eventIdx !== $setup.props.idx)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[34] || (_cache[34] = _createElementVNode("span", null, "신청인원", -1)),
                _createElementVNode("span", null, _toDisplayString($setup.state.cntApply) + " 명", 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "excel_btn icon_wrap",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.downloadFile(false)))
              }, [...(_cache[35] || (_cache[35] = [
                _createElementVNode("img", {
                  src: "img/excel_icon.png",
                  alt: ""
                }, null, -1)
              ]))]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("colgroup", null, [
                    _cache[36] || (_cache[36] = _createElementVNode("col", { style: {"min-width":"70px"} }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.formList, (form) => {
                      return (_openBlock(), _createElementBlock("col", _hoisted_12))
                    }), 256)),
                    _cache[37] || (_cache[37] = _createElementVNode("col", { style: {"min-width":"100px"} }, null, -1))
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[38] || (_cache[38] = _createElementVNode("th", null, "번호", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.formList, (form) => {
                        return (_openBlock(), _createElementBlock("th", _hoisted_13, _toDisplayString(form.title), 1))
                      }), 256)),
                      _cache[39] || (_cache[39] = _createElementVNode("th", null, "신청일", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    ($setup.state.cntApply > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.applyList, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.idx
                          }, [
                            _createElementVNode("td", null, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formList, (form) => {
                              return (_openBlock(), _createElementBlock("td", {
                                style: {"white-space":"pre-line"},
                                innerHTML: $setup.answerFormat(form)
                              }, null, 8, _hoisted_14))
                            }), 256)),
                            _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.createDate), ".")), 1)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("td", {
                            colspan: 2 + ($setup.state.formList.length > 0 ? $setup.state.formList.length : 0)
                          }, [...(_cache[40] || (_cache[40] = [
                            _createElementVNode("div", {
                              class: "tb_subject",
                              style: {"display":"block","text-align":"center","width":"100%"}
                            }, "신청 인원이 없습니다.", -1)
                          ]))], 8, _hoisted_16)
                        ]))
                  ])
                ])
              ]),
              _createVNode(_component_PageBtn, {
                currentPage: $setup.state.applyPage,
                perPage: $setup.state.size,
                totalLength: $setup.state.cntApply,
                onOnPaging: $setup.applyPaging
              }, null, 8, ["currentPage", "perPage", "totalLength", "onOnPaging"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "신청인원", -1)),
                _createElementVNode("span", null, _toDisplayString($setup.state.cntApply) + " 명", 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "excel_btn icon_wrap",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.downloadFile(false)))
              }, [...(_cache[42] || (_cache[42] = [
                _createElementVNode("img", {
                  src: "img/excel_icon.png",
                  alt: ""
                }, null, -1)
              ]))]),
              _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"list_th\" data-v-4768d288><span class=\"_num\" style=\"width:10%;\" data-v-4768d288>번호</span><span class=\"_name\" style=\"width:20%;\" data-v-4768d288>이름</span><span class=\"_name\" style=\"width:30%;\" data-v-4768d288>이메일</span><span class=\"_ph\" style=\"width:30%;\" data-v-4768d288>전화번호</span><span class=\"_ph\" style=\"width:15%;\" data-v-4768d288>연령대</span><span class=\"_date\" style=\"width:40%;\" data-v-4768d288>당신의 관심이 변화를 만듭니다.</span><span class=\"_date\" style=\"width:40%;\" data-v-4768d288>‘그들’이 아닌 ‘우리’의 문제입니다.</span><span class=\"_date\" style=\"width:40%;\" data-v-4768d288>존중과 인권을 이야기합니다.</span><span class=\"_date\" style=\"width:20%;\" data-v-4768d288>신청일</span></div>", 1)),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.applyList, (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "list_td",
                    key: item.idx
                  }, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(($setup.state.applyPage - 1) * $setup.state.size + (idx + 1)), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(item.name), 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(item.email), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString($setup.CommonUtils.convertPhoneNumReal(item.phoneNum)), 1),
                    (item.age === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "10대"))
                      : (item.age === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "20대"))
                        : (item.age === 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, "30대"))
                          : (item.age === 4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "40대"))
                            : (item.age === 5)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "50대"))
                              : (item.age === 6)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "60대"))
                                : (item.age === 7)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "70대 이상"))
                                  : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_32, [
                      _createElementVNode("label", {
                        for: 'chk_step1_0',
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step1_0',
                          "onUpdate:modelValue": ($event: any) => ((item.step1) = $event),
                          value: 0,
                          disabled: ""
                        }, null, 8, _hoisted_33), [
                          [_vModelCheckbox, item.step1]
                        ])
                      ]),
                      _createElementVNode("label", {
                        for: 'chk_step1_1',
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step1_1',
                          "onUpdate:modelValue": ($event: any) => ((item.step1) = $event),
                          value: 1,
                          disabled: ""
                        }, null, 8, _hoisted_34), [
                          [_vModelCheckbox, item.step1]
                        ])
                      ]),
                      _createElementVNode("label", {
                        for: 'chk_step1_2',
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step1_2',
                          "onUpdate:modelValue": ($event: any) => ((item.step1) = $event),
                          value: 2,
                          disabled: ""
                        }, null, 8, _hoisted_35), [
                          [_vModelCheckbox, item.step1]
                        ])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_36, [
                      _createElementVNode("label", {
                        for: 'chk_step2_0',
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step2_0',
                          "onUpdate:modelValue": ($event: any) => ((item.step2) = $event),
                          value: 0,
                          disabled: ""
                        }, null, 8, _hoisted_37), [
                          [_vModelCheckbox, item.step2]
                        ])
                      ]),
                      _createElementVNode("label", {
                        for: 'chk_step2_1',
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step2_1',
                          "onUpdate:modelValue": ($event: any) => ((item.step2) = $event),
                          value: 1,
                          disabled: ""
                        }, null, 8, _hoisted_38), [
                          [_vModelCheckbox, item.step2]
                        ])
                      ]),
                      _createElementVNode("label", {
                        for: 'chk_step2_2',
                        onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step2_2',
                          "onUpdate:modelValue": ($event: any) => ((item.step2) = $event),
                          value: 2,
                          disabled: ""
                        }, null, 8, _hoisted_39), [
                          [_vModelCheckbox, item.step2]
                        ])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_40, [
                      _createElementVNode("label", {
                        for: 'chk_step3_0',
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step3_0',
                          "onUpdate:modelValue": ($event: any) => ((item.step3) = $event),
                          value: 0,
                          disabled: ""
                        }, null, 8, _hoisted_41), [
                          [_vModelCheckbox, item.step3]
                        ])
                      ]),
                      _createElementVNode("label", {
                        for: 'chk_step3_1',
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step3_1',
                          "onUpdate:modelValue": ($event: any) => ((item.step3) = $event),
                          value: 1,
                          disabled: ""
                        }, null, 8, _hoisted_42), [
                          [_vModelCheckbox, item.step3]
                        ])
                      ]),
                      _createElementVNode("label", {
                        for: 'chk_step3_2',
                        onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk_step3_2',
                          "onUpdate:modelValue": ($event: any) => ((item.step3) = $event),
                          value: 2,
                          disabled: ""
                        }, null, 8, _hoisted_43), [
                          [_vModelCheckbox, item.step3]
                        ])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_44, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.createDate), ".")), 1)
                  ]))
                }), 128))
              ]),
              _createVNode(_component_PageBtn, {
                currentPage: $setup.state.applyPage,
                perPage: $setup.state.size,
                totalLength: $setup.state.cntApply,
                onOnPaging: $setup.applyPaging
              }, null, 8, ["currentPage", "perPage", "totalLength", "onOnPaging"])
            ])
          ])),
      _createElementVNode("div", _hoisted_45, [
        ($setup.state.eventIdx !== $setup.props.idx)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", null, [
                _cache[44] || (_cache[44] = _createElementVNode("label", { for: "cntWin" }, "당첨인원", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "cntWin",
                  type: "number",
                  placeholder: "당첨인원을 입력해주세요.",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.data.cntWin) = $event))
                }, null, 512), [
                  [_vModelText, $setup.state.data.cntWin]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { for: "memo" }, "메모", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "memo",
                  placeholder: "메모",
                  class: "custom_scroll light_gray",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.data.memo) = $event))
                }, null, 512), [
                  [_vModelText, $setup.state.data.memo]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("div", null, [
                _cache[52] || (_cache[52] = _createElementVNode("h1", null, "당신의 관심이 변화를 만듭니다.", -1)),
                _createElementVNode("p", _hoisted_48, [
                  _createElementVNode("label", {
                    onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[46] || (_cache[46] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[47] || (_cache[47] = _createTextVNode(" 외면도, 무관심도, 침묵도 성매매 카르텔입니다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_49, [
                  _createElementVNode("label", {
                    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[48] || (_cache[48] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[49] || (_cache[49] = _createTextVNode(" ANTI 성매매에 끊임없이 관심을 가집시다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_50, [
                  _createElementVNode("label", {
                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[50] || (_cache[50] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[51] || (_cache[51] = _createTextVNode(" 성매매는 사회의 병적인 존재다. 이제는 변화해야 한다. 제발... ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[59] || (_cache[59] = _createElementVNode("h1", null, "‘그들’이 아닌 ‘우리’의 문제입니다.", -1)),
                _createElementVNode("p", _hoisted_51, [
                  _createElementVNode("label", {
                    onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[53] || (_cache[53] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[54] || (_cache[54] = _createTextVNode(" 성매매 문제는 남의 일이 아닙니다. 우리가 반드시 해결해야 하므로 함께 해 주십시오 ", -1))
                ]),
                _createElementVNode("p", _hoisted_52, [
                  _createElementVNode("label", {
                    onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[55] || (_cache[55] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[56] || (_cache[56] = _createTextVNode(" '그들'(성매매 여성)만의 문제가 아닌 '우리'(여성 그리고 모두)의 문제입니다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_53, [
                  _createElementVNode("label", {
                    onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[57] || (_cache[57] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[58] || (_cache[58] = _createTextVNode(" 성매매는 '불법', 성구매자는 '전과자'입니다. ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[66] || (_cache[66] = _createElementVNode("h1", null, "존중과 인권을 이야기합니다.", -1)),
                _createElementVNode("p", _hoisted_54, [
                  _createElementVNode("label", {
                    onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[60] || (_cache[60] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[61] || (_cache[61] = _createTextVNode(" 성매매는 인권의 문제! 성매매라고 쓰고 성착취(성폭력)라고 읽는다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_55, [
                  _createElementVNode("label", {
                    onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[62] || (_cache[62] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[63] || (_cache[63] = _createTextVNode(" 2차 피해만큼은 하지 마십시오. 당신도 똑같은 가해자입니다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_56, [
                  _createElementVNode("label", {
                    onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[64] || (_cache[64] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[65] || (_cache[65] = _createTextVNode(" 성매매 없는 사회, 인간의 존중과 가치를 보여주세요. ", -1))
                ])
              ])
            ]))
      ]),
      ($setup.state.eventIdx !== $setup.props.idx)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("button", {
              class: "submit_btn w_120",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
            }, "확인")
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[25] || (_cache[25] = ($event: any) => ($setup.state.isShowModal = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowAnswer)
      ? (_openBlock(), _createBlock(_component_AnswerModal, {
          key: 1,
          answerInfo: $setup.state.answerInfo,
          onClose: _cache[26] || (_cache[26] = ($event: any) => ($setup.state.isShowAnswer = false)),
          onCallback: _cache[27] || (_cache[27] = ($event: any) => {
            $setup.state.isShowAnswer = false;
            $setup.getApplyList();
        })
        }, null, 8, ["answerInfo"]))
      : _createCommentVNode("", true)
  ], 64))
}